/* START_MODULE_CONTRACT
 * PURPOSE: Frontend model накладного расхода с правилом периодичности (UC-013).
 * SCOPE: DTO mapping / summary labels.
 * DEPENDS: overheadConstants, overheadUtils
 * LINKS: M-FE-API, M-PROJECT-OVERHEAD
 * ROLE: TYPES
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * ProjectOverhead - клиентская модель overhead
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-03 - UC-013: recurrenceType вместо periodUnit.
 * END_CHANGE_SUMMARY
 */

import { formatRecurrenceLabel } from '../pages/projects/components/overheadUtils';

/* START_CLASS_ProjectOverhead */
/* START_CONTRACT: ProjectOverhead
 * PURPOSE: Клиентская модель накладного расхода с построением подписей.
 * INPUTS: { id, projectId, name, hoursPerEmployee, recurrence fields, roleIds, createdAt }.
 * OUTPUTS: экземпляр ProjectOverhead; getRoleLabels(), getSummaryLabel().
 * SIDE_EFFECTS: нет.
 * LINKS: M-FE-API, M-PROJECT-OVERHEAD
 * END_CONTRACT: ProjectOverhead
 */
export default class ProjectOverhead {
  constructor({
    id,
    projectId,
    name,
    hoursPerEmployee,
    recurrenceType,
    intervalDays,
    daysOfWeek,
    roleIds,
    createdAt,
  }) {
    this.id = id;
    this.projectId = projectId;
    this.name = name ?? '';
    this.hoursPerEmployee = hoursPerEmployee;
    this.recurrenceType = recurrenceType;
    this.intervalDays = intervalDays ?? null;
    this.daysOfWeek = daysOfWeek ?? null;
    this.roleIds = roleIds ?? [];
    this.createdAt = createdAt ? new Date(createdAt) : null;
  }

  /* START_METHOD_getRoleLabels */
  getRoleLabels(allRoles) {
    if (!this.roleIds.length || !allRoles?.length) {
      return [];
    }
    const roleMap = new Map(allRoles.map((role) => [role.id, role]));
    return this.roleIds
      .map((id) => roleMap.get(id))
      .filter(Boolean)
      .map((role) => role.shortName || role.name);
  }
  /* END_METHOD_getRoleLabels */

  /* START_METHOD_getSummaryLabel */
  getSummaryLabel(allRoles) {
    const recurrenceLabel = formatRecurrenceLabel({
      recurrenceType: this.recurrenceType,
      intervalDays: this.intervalDays,
      daysOfWeek: this.daysOfWeek,
    });
    const roleLabels = this.getRoleLabels(allRoles);
    const rolesText = roleLabels.length ? roleLabels.join(', ') : '—';
    return `${this.name}: ${this.hoursPerEmployee} ч, ${recurrenceLabel} — ${rolesText}`;
  }
  /* END_METHOD_getSummaryLabel */

  static fromResponse(data) {
    return new ProjectOverhead(data);
  }
}
/* END_CLASS_ProjectOverhead */
